"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.schedule.date': 'Fecha de publicación',
    'socialMediaPlan.schedule.time': 'Hora',
    'socialMediaPlan.schedule.summary': 'Resumen',
    'socialMediaPlan.schedule.draftTitle': 'Borrador',
    'socialMediaPlan.schedule.draftDesc': 'Guardar como borrador',
    'socialMediaPlan.schedule.reviewTitle': 'Revisión',
    'socialMediaPlan.schedule.reviewDesc': 'Solicitar revisión',
    'socialMediaPlan.schedule.scheduledTitle': 'Programado',
    'socialMediaPlan.schedule.scheduledDesc': 'Programar para más tarde',
    'socialMediaPlan.schedule.publishedTitle': 'Publicado',
    'socialMediaPlan.schedule.publishedDesc': 'Publicar ahora',
};
